<template>
    <Teleport to="body">
        <Transition name="billing-result-fade">
            <div v-if="result" :class="['billing-payment-result-overlay', result.status === 'success' ? 'billing-payment-result-overlay--success' : 'billing-payment-result-overlay--failed']">
                <div class="billing-payment-result-card">
                    <template v-if="result.status === 'success'">
                        <div class="billing-payment-result-icon billing-payment-result-icon--success billing-result-icon--pop">
                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
                        </div>
                        <div class="billing-payment-result-title">{{ $t('common.billing.externalPaymentSuccess') }}</div>
                        <div class="billing-payment-result-order">#{{ result.orderId }} &middot; {{ result.orderName }}</div>
                        <div class="billing-payment-result-amount">{{ formatPrice(result.amount) }}&#8378;</div>
                    </template>
                    <template v-else>
                        <div class="billing-payment-result-icon billing-payment-result-icon--failed billing-result-icon--shake">
                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                        </div>
                        <div class="billing-payment-result-title">{{ $t('common.billing.externalPaymentFailed') }}</div>
                        <div class="billing-payment-result-desc">{{ result.error }}</div>
                    </template>
                    <button class="billing-payment-result-btn" @click="onOpenPanel">{{ $t('common.billing.openBillingPanel') }}</button>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
import billingService from './billingService'

export default {
    name: 'BillingPaymentResult',
    computed: {
        result() {
            return billingService.state.externalPaymentResult
        },
    },
    methods: {
        formatPrice: billingService.formatPrice,
        onOpenPanel() {
            const orderId = this.result?.orderId
            billingService.clearExternalPaymentResult()
            if (orderId) {
                billingService.selectOrder(orderId)
            }
        },
        onKeyDown(e) {
            if (e.key === 'Escape' && this.result) {
                billingService.clearExternalPaymentResult()
            }
        },
    },
    mounted() {
        document.addEventListener('keydown', this.onKeyDown)
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onKeyDown)
    },
}
</script>
